import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './product-item-labels.component.html';
var metaRefurbishedAttribute = "Meta_Refurbished" + "|true";
var metaDuscontinuedAttribute = "Meta_Discontinued" + "|true";
var specialOfferLabel = "Meta_SpecialOffer";
var ProductItemLabelsComponent = (function () {
    function ProductItemLabelsComponent() {
        this.showSpecialOffer = false;
        this.labels = [];
    }
    ProductItemLabelsComponent.prototype.ngOnChanges = function () {
        var _a;
        this.labels = (this.attributes || [])
            .filter(function (a) {
            return a.toLowerCase() === metaDuscontinuedAttribute || a.toLowerCase() === metaRefurbishedAttribute;
        })
            .filter(function (label, index, context) { return context.indexOf(label) === index; })
            .map(function (f) { return f.split('|')[0]; })
            .sort(function (f1, f2) {
            if (f1 > f2) {
                return 1;
            }
            if (f1 < f2) {
                return -1;
            }
            return 0;
        });
        if (this.labels.length === 0 && this.showSpecialOffer && ((_a = this.price) === null || _a === void 0 ? void 0 : _a.isDiscounted)) {
            this.labels = [specialOfferLabel];
        }
    };
    ProductItemLabelsComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductItemLabelsComponent.prototype, "attributes", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductItemLabelsComponent.prototype, "price", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductItemLabelsComponent.prototype, "showSpecialOffer", void 0);
    ProductItemLabelsComponent = __decorate([
        Component({
            selector: 'productItemLabels',
            template: template,
        })
    ], ProductItemLabelsComponent);
    return ProductItemLabelsComponent;
}());
export { ProductItemLabelsComponent };
